import { Droplets, Plug, Wifi, Table2, Waves } from "lucide-react";
import { mapHookupHighlights, type SiteIncludeIcon } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const iconMap: Partial<Record<SiteIncludeIcon, typeof Plug>> = {
  water: Droplets,
  sewer: Waves,
  power: Plug,
  wifi: Wifi,
  picnic: Table2,
};

export function MapIncludes() {
  return (
    <section aria-labelledby="map-includes-heading" className="bg-background py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>At Your Site</Eyebrow>
        </Reveal>
        <h2 id="map-includes-heading" className="display-lg mt-6">
          <MaskReveal>Full Hookups Come Standard</MaskReveal>
        </h2>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {mapHookupHighlights.map((item, i) => {
            const Icon = iconMap[item.icon] ?? Plug;
            return (
              <li key={item.id}>
                <Reveal delay={i * 0.04}>
                  <div className="flex h-full flex-col items-start border border-border bg-card p-6">
                    <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary/40 text-primary">
                      <Icon className="size-5" strokeWidth={1.4} />
                    </span>
                    <h3 className="font-display mt-6 text-xl tracking-tight">{item.title}</h3>
                  </div>
                </Reveal>
              </li>
            );
          })}
        </ul>

        <Reveal delay={0.1}>
          <p className="mt-8 max-w-3xl text-sm leading-relaxed text-muted-foreground">
            Individual site characteristics and availability vary. Contact Auburn RV Resort to
            confirm the best available option for your RV.
          </p>
          <ResortLink variant="solid" href="/accommodations/" className="mt-8 w-full sm:w-auto">
            View Full Accommodations
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
